import { makeStyles } from "tss-react/mui"
import { Stack } from "@mui/material"
import { faArrowsRotate } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { OrderRecurrence } from "../../home/weekMenuTypes"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import {
    SectionItemData,
    SectionTitle,
} from "../../../../../shared/components/dialogs/receiptConfirmOrderDialog/components/common/ReceiptPrimitives"

const useStyles = makeStyles()((theme) => ({
    icon: {
        color: tailwindPalette.slate[400],
        marginTop: ".25rem",
    },
    title: {
        padding: "0 1.25rem",
    },
    sectionTitle: {
        paddingLeft: "1.25rem",
    },
    container: {
        "@media print": {
            display: "none",
        },
        [theme.breakpoints.down("sm")]: {
            borderBottom: `1px solid ${theme.palette.divider}`,
            paddingBottom: "2rem",
        },
    },
}))

type RepeatOrderProps = Readonly<{
    recurrence: OrderRecurrence
}>

export function RepeatOrder({ recurrence }: RepeatOrderProps) {
    const { classes } = useStyles()

    return (
        <Stack spacing="1rem" className={classes.container}>
            <SectionTitle classNames={classes.sectionTitle} translationKey="confirm-order-dialog-repeat-order-text">
                Repeat order
            </SectionTitle>
            <Stack flexDirection="row" gap=".5rem" className={classes.title}>
                <FontAwesomeIcon icon={faArrowsRotate} className={classes.icon} />
                <SectionItemData>{recurrence.description}</SectionItemData>
            </Stack>
        </Stack>
    )
}
